import axios from 'axios'
import {VERSION, API_URL} from '@/config/constants'
import { i18n } from '@/i18n'

let client = axios.create({
  baseURL: API_URL,
  headers: {
    'X-Solo-Web-Version': VERSION
  }
})
export {client as api}

let docs = axios.create()
export {docs}

// TODO: check for API "401" response, ensure redirect to "/login"
// TODO: figure out how to check for new deployments... may need to poll a server route?
// TODO: setTimeout to use "refresh" token

// map of backend api error strings to i18n keys
const apiErrorsI18N = {
  'Email not found': 'loginErrors.noEmail',
  'Password incorrect': 'loginErrors.wrongPassword',
  'linguist profile not allowed on zoom app': 'loginErrors.linguistNotAllowed',
  "couldn't fetch the scheduled meetings" : 'session.create.error.reInstall',
  'device missing zoom refresh token': 'session.create.error.reInstall',
  'zoom user id not found: pg: no rows in result set': 'session.create.error.reLogin',
  'no meeting found': 'session.create.error.noMeeting',
  'payment details required': 'session.create.error.noPaymentMethod',
  'There was an error logging out': 'auth.logoutError',
//   "both email and password required": "auth.loginError",
//   "user not found": "auth.noUserError",
//   "Email not found": "auth.noEmailError",
//   "Password incorrect": "auth.passwordIncorrectError",
//   "authentication required": "auth.authRequiredError",
//   "user already exists": "auth.userExistsError",
//   "email already exists": "profile.referrer.userExists",
//   "cannot find specified token": "customerRegistration.tokenMissingError",
//   "Account with this email already exists": "memberManagement.add.errAlreadyExists",
}

// this is primarily used by the vuex store auth module to update
// the jwt token as needed
function setAuthToken(str) {
  if (str == null) {
    delete client.defaults.headers.common['Authorization']
  } else {
    client.defaults.headers.common['Authorization'] = 'Bearer ' + str
  }
}

// this will get set dynamically depending on whether or not a user is logged in
let responseInterceptor = null
function setAuthFailureHandler(resFN, errFN) {
  responseInterceptor = client.interceptors.response.use(resFN, errFN)
}

function clearAuthFailureHandler() {
  client.interceptors.response.eject(responseInterceptor)
}

// handle error responses and try to extract
// an error message from the body if present,
// otherwise fall back to a default error message
function translateApiError(e, i18nDefaultKey) {
  // some api error responses might be changed through a series of
  // promises - so it's possible that the return has already
  // been turned into a string
  if ("string" == typeof e) {
    if (apiErrorsI18N[e]) {
      return i18n.global.t(apiErrorsI18N[e])
    }
    if (i18nDefaultKey) {
      return i18n.global.t(i18nDefaultKey)
    }
    return e
  }

  // otherwise check for a response error data strcture
  if (e.response && e.response.data && e.response.data.errors) {
    let key = e.response.data.errors[0]
    if (apiErrorsI18N[key] != null || apiErrorsI18N[key] != undefined) {
      return i18n.global.t(apiErrorsI18N[key])
    } else {
      return e.response.data.errors[0]
    }
  }

  if (i18nDefaultKey != null || i18nDefaultKey != undefined) {
    return i18n.global.t(i18nDefaultKey)
  }

  return i18n.global.t('loginErrors.default')
}

export {
  setAuthToken,
  setAuthFailureHandler,
  clearAuthFailureHandler,
  translateApiError
}
